module.exports = __webpack_public_path__ + "img/icon_map_2_5_yj_hg.7af1c9b4.png";